<template>
	<Board :paused="!loop" @click="() => {if (!loop) start()}"/>
	<PauseModal v-if="!loop" @click="start"/>
</template>

<script>
import Board from './components/Board.vue'
import PauseModal from './components/PauseModal.vue'

export default {
	name: 'App',
	components: {
		Board,
		PauseModal,
	},
	data() {
		return {
			loop: false,
			interval: 1000,
		}
	},
	methods: {
		handleControl(event) {
			if (event.code === 'Escape') {
				if (this.loop) this.pause()
				else this.start()
			} else if (!this.loop) return
			switch (event.code) {
			case 'ArrowLeft':
				this.$root.$el.dispatchEvent(new CustomEvent('move', { detail: { x: -1, y: 0, r: 0 } }))
				break
			case 'ArrowRight':
				this.$root.$el.dispatchEvent(new CustomEvent('move', { detail: { x: 1, y: 0, r: 0 } }))
				break
			case 'ArrowDown':
				this.$root.$el.dispatchEvent(new CustomEvent('move', { detail: { x: 0, y: 1, r: 0 } }))
				break
			case 'ArrowUp':
				this.$root.$el.dispatchEvent(new CustomEvent('move', { detail: { x: 0, y: 0, r: 1 } }))
				break
			case 'Space':
				this.$root.$el.dispatchEvent(new CustomEvent('drop'))
				break
			case 'ShiftLeft':
			case 'ShiftRight':
				this.$root.$el.dispatchEvent(new CustomEvent('hold'))
				break
			}
		},
		start() {
			this.loop = setTimeout(this.tick, this.interval)
		},
		pause() {
			clearTimeout(this.loop)
			this.loop = false
		},
		tick() {
			this.$root.$el.dispatchEvent(new CustomEvent('tick'))
			this.loop = setTimeout(this.tick, this.interval)
		},
	},
	mounted() {
		window.addEventListener('keydown', this.handleControl)
		window.addEventListener('blur', this.pause)
		this.start()
	},
	unmounted() {
		window.removeEventListener('keydown', this.handleControl)
		window.removeEventListener('blur', this.pause)
	},
}
</script>

<style lang="scss">
body {
	margin: 0;
	height: 100vh;
	@media (prefers-color-scheme: dark) {
		background-color: #202124;
	}
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
	display: flex;
	text-align: center;
	color: #2c3e50;
}
</style>
